<template>
    <v-footer>
        <v-layout column justify-center md6 class="footer">
<!--            <v-flex xs12>-->
<!--                <div style="height: 60px;background-color: white;"></div>-->
<!--            </v-flex>-->
            <v-flex xs12 style="background-color: #527281;">
                <v-flex class="my-12">
                    <v-layout>
                    <v-flex xs12>
                        <img alt="Vue logo" src="../assets/logo.png" style="width: 40px">
                    </v-flex>
                </v-layout>
                    <v-layout class="my-2">
                        <v-flex xs12 style="color: #fff;  font-size: 18px">
                            กรมการแพทย์ทหารบก
                        </v-flex>
                    </v-layout>
                    <v-layout justify-center class="my-2">
                        <v-flex xs6 sm4 md2>
                            <div style="border-top: solid 2px #FFF; width: 100%; box-shadow: 0 4px 3px rgba(0,0,0,.25)"></div>
                        </v-flex>
                    </v-layout>
                    <v-layout class="my-2">
                        <v-flex xs12 style="color: #fff; font-size: 14px">
                            <v-icon style="color: #fff;">room</v-icon>
                            : เลขที่ 8 ถนนพญาไท แขวงทุ่งพญาไท เขตราชเทวี กรุงเทพฯ10400
                        </v-flex>
                    </v-layout>
                    <v-layout class="my-2">
                        <v-flex xs12 style="color: #fff; font-size: 14px">
                            <v-icon style="color: #fff;">call</v-icon>
                            : โทร 02-354-4422
                        </v-flex>
                    </v-layout>
                </v-flex>

            </v-flex>
        </v-layout>

    </v-footer>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped>
    .v-footer {
        padding: 0px;
    }
</style>